import cn from 'classnames'

import { IPercentSliderProps } from './percent-slider.props'
import styles from './styles.module.scss'

export default function PercentSlider({
  percentCoefficient,
  amountPercent,
  defaultFrom,
  changePercent,
  className,
}: IPercentSliderProps) {
  return (
    <div className={cn(styles.amountContainer, className)}>
      <div
        className={cn(styles.amountPercent, { [styles.amountPercent_disabled]: defaultFrom === 0 })}
        style={
          {
            '--percent': `${
              amountPercent === 100
                ? 83.5
                : Math.round(amountPercent * 0.8 + (amountPercent !== 0 ? percentCoefficient : 0))
            }%`,
            '--content-val': `'${amountPercent}%'`,
          } as object
        }
      >
        <button
          disabled={defaultFrom === 0}
          onClick={() => changePercent(0)}
          className={cn(styles.amountPercent__item)}
        >
          0%
        </button>
        <button
          disabled={defaultFrom === 0}
          onClick={() => changePercent(25)}
          className={cn(styles.amountPercent__item)}
        >
          25%
        </button>
        <button
          disabled={defaultFrom === 0}
          onClick={() => changePercent(50)}
          className={cn(styles.amountPercent__item)}
        >
          50%
        </button>
        <button
          disabled={defaultFrom === 0}
          onClick={() => changePercent(75)}
          className={cn(styles.amountPercent__item)}
        >
          75%
        </button>
        <button
          disabled={defaultFrom === 0}
          onClick={() => changePercent(100)}
          className={cn(styles.amountPercent__item)}
        >
          100%
        </button>
      </div>
    </div>
  )
}
